import { useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { API_BASE } from './config';
import { connectSocket } from '../socket/socket';
import '../css/JoinCheckin.css';
import { resolveAvatarSource } from '../utils/avatar';

const avatarSource = value => {
  return resolveAvatarSource(value);
};

export default function QrCheckinLogin() {
  const { groupId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const code = useMemo(() => new URLSearchParams(location.search).get('code') || '', [location.search]);
  const player = location.state?.player || null;
  const groupName = location.state?.groupName || 'เช็คอินเข้าสนาม';
  const qrPath = `/join/${groupId}?code=${encodeURIComponent(code)}`;
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const loginAndJoin = async event => {
    event.preventDefault();
    if (!player || busy) return;
    try {
      setBusy(true);
      setMessage('');
      const response = await fetch(`${API_BASE}/api/checkin/join/${groupId}/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, userId: player.user_id, password })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.message || 'เข้าสู่ระบบไม่สำเร็จ');
      localStorage.setItem('device_token', data.deviceToken);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('last_group_id', String(groupId));
      connectSocket(data.token);
      navigate(qrPath, { replace: true, state: { checkinUser: data.user } });
    } catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  };

  if (!player) return (
    <main className="join-page"><section className="join-card">
      <div className="join-error">ไม่พบข้อมูลสมาชิก กรุณาค้นหาชื่อใหม่</div>
      <button className="join-primary" type="button" onClick={() => navigate(qrPath, { replace: true })}>กลับไปค้นหาสมาชิก</button>
    </section></main>
  );

  return (
    <main className="join-page"><section className="join-card">
      <button className="join-back" type="button" onClick={() => navigate(qrPath, { replace: true })}>← เลือกชื่อใหม่</button>
      <div className="join-mark">🔐</div><small>เข้าสู่ระบบเพื่อเช็กอิน</small><h1>{groupName}</h1>
      <form className="join-login" onSubmit={loginAndJoin}>
        <span className="join-avatar large">{player.avatar_url ? <img src={avatarSource(player.avatar_url)} alt="" /> : player.name?.charAt(0)}</span>
        <h2>{player.name}</h2><p>รหัสผู้เล่น {player.user_id} • ระดับมือ {player.level_rank || '-'}</p>
        <input type="password" autoFocus value={password} onChange={event => setPassword(event.target.value)} placeholder="Password / PIN" autoComplete="current-password" required />
        {message && <div className="join-error">{message}</div>}
        <button className="join-primary" disabled={busy}>{busy ? 'กำลังเช็คอิน…' : 'เข้าสู่ระบบและเช็คอิน'}</button>
      </form>
    </section></main>
  );
}
